module.exports = __webpack_public_path__ + "img/frame (166).7ea4ad11.jpg";